module.exports = __webpack_public_path__ + "img/電気回路_6_10_2.5d211ddd.png";